import styled from 'styled-components';
import { FlexCenterAligned } from '../../../styled/common';

export const ChevronWrapper = styled(FlexCenterAligned)<{
  $isOpen?: boolean;
  $isDisabled?: boolean;
}>`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(270deg)' : 'rotate(90deg)')};

  svg path {
    fill: ${({ theme, $isDisabled }) =>
      $isDisabled ? theme.colors.text.tertiary : theme.colors.text.secondary};
  }
`;
